var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "as-standards-wrap" }, [
    _c("div", { staticClass: "as-standards-title" }, [_vm._v("售后标准")]),
    _vm._v(" "),
    _c("div", { staticClass: "as-standards-content" }, [
      _vm._v("\n    " + _vm._s(_vm.standardTxt || "--") + "\n    ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78f9bc2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f9bc2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aftersale/as-standard.vue
// module id = null
// module chunks = 